import { Vector3toV3 as j } from "../index10.js";
function u(e, t) {
  e = j(e), t = t.map(j);
  const m = e[0], c = e[2];
  let i = !1;
  for (let s = 0, r = t.length - 1; s < t.length; r = s++) {
    const f = t[s][0], n = t[s][2], a = t[r][0], x = t[r][2];
    n > c != x > c && m < (a - f) * (c - n) / (x - n) + f && (i = !i);
  }
  return i;
}
export {
  u as isPointInside
};
//# sourceMappingURL=index19.js.map
